import script from "./GridComandaDetalii.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridComandaDetalii.vue?vue&type=script&lang=ts&setup=true"

import "./GridComandaDetalii.vue?vue&type=style&index=0&id=ab4ea462&scoped=true&lang=css"
import "./GridComandaDetalii.vue?vue&type=style&index=1&id=ab4ea462&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab4ea462"]])

export default __exports__